import { Injectable } from "@angular/core";

import { CommonState } from "../../state";

import { LoginLimitProgressState, LoginLimitState } from "./login-limit.model";

@Injectable({
	providedIn: "root",
})
export class LoginLimitSelector {
	getLoginLimit() {
		return (state: CommonState): LoginLimitState | undefined => state.loginLimit;
	}

	getLoginLimitProgress() {
		return (state: CommonState): LoginLimitProgressState | undefined => state.loginLimitProgress;
	}
}
